import {CreateSelector} from "../../../App/store";
import {DictionaryType} from "../../../../helper/types";
import {StationFullType} from "../../../../Services/api/v2";
import {createSelector} from "@reduxjs/toolkit";
import {stationsFullSelectorMonitoring} from "../../../App/Dictionaries/selectors";
import {getStationFullIds} from "../../../Filters/Stations";
import {
    selectedRegionIdsSelectorMonitoring,
    selectedTypeIdSelectorMonitoring,
    stationSearchTextSelectorMonitoring
} from "../../Selectors/filtersSliceMonitoring";
import {filteredDatasourcesIdsSelectorMonitoring} from "../Datasource/selectorsMonitoring";
import {FilterStationsFullMonitoring} from "./filtersMonitoring";

export const filteredStationsFullSelectorMonitoring: CreateSelector<DictionaryType<StationFullType>> = createSelector(
    [
        stationsFullSelectorMonitoring,
        stationSearchTextSelectorMonitoring,
        selectedRegionIdsSelectorMonitoring,
        filteredDatasourcesIdsSelectorMonitoring,
        selectedTypeIdSelectorMonitoring
    ],
    (stationsFull, searchText, regionIds, datasourceIds, typeId) => {
        const filtered = FilterStationsFullMonitoring
            .setValues(Object.values(stationsFull))
            .bySearchText(searchText)
            .byRegionIds(regionIds)
            .byDatasourceIds(datasourceIds)
            .byTypeId(typeId);
        return filtered.getDictionary();
    },
);

export const filteredStationsIdsSelectorMonitoring: CreateSelector<number[]> = createSelector(
    filteredStationsFullSelectorMonitoring,
    (stationsFull) => {
        return getStationFullIds(stationsFull);
    },
);

export const filteredStationsIdsLengthSelectorMonitoring = createSelector(
    filteredStationsIdsSelectorMonitoring,
    (ids) => ids.length,
);

export const stationDatasourceIdsFromFilteredSelectorMonitoring = (stationId: number):CreateSelector<number[]> => createSelector(
    filteredStationsFullSelectorMonitoring,
    (stationsFull) => {
        const { datasourceIds } = stationsFull[stationId];
        return datasourceIds;
    },
);